// -------------------------------
// src/pages/AddProperty.js
// -------------------------------
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { getApiUrl } from '../config/api';
import authFetch from '../utils/authFetch';

const AddProperty = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', address: '', description: '' });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);

    try {
      const res = await authFetch(getApiUrl('/api/v1/property/create'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          property_name: form.name,
          property_address: form.address,
          description: form.description
        })
      });

      if (!res.ok) throw new Error(`Server responded ${res.status}`);

      // on success, redirect back to list view
      navigate('/properties');
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout pageTitle="Add New Property">
      <div className="max-w-xl mx-auto space-y-6">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1" htmlFor="name">Property Name</label>
            <input
              id="name"
              name="name"
              type="text"
              required
              value={form.name}
              onChange={handleChange}
              className="w-full border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-zenrent-green-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1" htmlFor="address">Address</label>
            <input
              id="address"
              name="address"
              type="text"
              required
              value={form.address}
              onChange={handleChange}
              className="w-full border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-zenrent-green-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1" htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              rows="3"
              value={form.description}
              onChange={handleChange}
              className="w-full border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-zenrent-green-500"
            />
          </div>

          {error && <p className="text-red-600 text-sm">{error}</p>}

          <div className="flex items-center gap-3">
            <button
              type="submit"
              disabled={submitting}
              className="bg-zenrent-green-600 hover:bg-zenrent-green-700 text-white rounded-lg px-4 py-2 shadow disabled:opacity-50"
            >
              {submitting ? 'Saving…' : 'Save Property'}
            </button>
            <button
              type="button"
              onClick={() => navigate('/properties')}
              className="bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg px-4 py-2"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </Layout>
  );
};

export default AddProperty;